import { combineReducers } from "redux";

import app from "./app";
import messages from "./messages";
import conversation from "./conversation";
import config from "./config";
import authentication from "./authentication";
import theme from "./theme";

export default combineReducers({
    messages,
    config,
    conversation,
    authentication,
    app,
    theme
});